import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function PreviewIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 14} height={height || 9.545} viewBox="0 0 14 9.545">
      <path
        data-name="Path 1465"
        d="M8 4.5a7.526 7.526 0 00-7 4.773 7.52 7.52 0 0014 0A7.526 7.526 0 008 4.5zm0 7.955a3.182 3.182 0 113.182-3.182A3.183 3.183 0 018 12.455zm0-5.091a1.909 1.909 0 101.909 1.909A1.907 1.907 0 008 7.364z"
        transform="translate(-1 -4.5)"
        fill={color || "#555"}
      />
    </svg>
  );
}
